// eslint-disable-next-line @typescript-eslint/no-var-requires
const pjson = require('../../package.json');

const config = {
    VERSION: pjson.version,
};

export const MOCK_SERVER = false;
export const PUBLIC_URL = process.env.REACT_APP_PUBLIC_URL;
export const SERVER_API_URL = process.env.REACT_APP_SERVER_API_URL || '/api';

export const LS_AUTH_TOKEN = 'authToken';
export const LS_DEFAULT_LOCALE = 'cs_defaultLocale';
export const DEFAULT_LOCALE = 'uk';
export const getDefaultLocale = () => localStorage.getItem(LS_DEFAULT_LOCALE) || DEFAULT_LOCALE;

export const AVAILABLE_LOCALES = {
    UK: 'uk',
    EN: 'en',
};

export const AUTHORITIES = {
    ADMIN: 'ROLE_ADMIN',
    USER: 'ROLE_USER',
};

export const LAYOUT = {
    TREE: 'tree',
    GRID: 'grid',
    LIST: 'list',
    FILTER: 'filter',
};

export const FULL_DATE_FORMAT = 'DD/MM/YYYY HH:mm:ss';
export const DATE_FORMAT = 'DD/MM/YYYY';
export const TIME_FORMAT = 'HH:mm:ss';
export const PAGINATOR_TMPL = `CurrentPageReport RowsPerPageDropdown FirstPageLink
                                PrevPageLink PageLinks NextPageLink LastPageLink`;
export const PAGE_REPORT = '{first} – {last} з {totalRecords} елементів';
export const ITEM_PER_PAGE = 10;
export const ROWS_PER_PAGE = [10, 20, 50, 100, 500];
export const ITEM_PER_PAGE_GRID = 9;
export const ROWS_PER_PAGE_GRID = [9, 18, 36, 72, 144, 288];
export const NO_RECORDS = 'Нема жодного запису';
export const SELECTED_COUNT = 'Вибрано {0}';
export const BTN_SECONDARY_CLS = 'p-button-outlined p-button-secondary';

export const ROUTE = {
    LOGIN: '/login',
    SITE: '/site/',
    OKKO_PAY: '/okko-pay',
    STORE: '/store/',
    ORDER: '/order/',
    BOLT_PIM: '/bolt-pim/',
};

export const GoodUnit = {
    PCS: 'pcs',
    KG: 'kg',
    GR: 'gr',
    L: 'l',
    ML: 'ml',
};

export const GoodUnitUkr = {
    '': '',
    [GoodUnit.PCS]: 'шт',
    [GoodUnit.KG]: 'кг',
    [GoodUnit.GR]: 'гр',
    [GoodUnit.L]: 'л',
    [GoodUnit.ML]: 'мл',
};

export interface INavItem {
    id?: number;
    label: string;
    symbol?: string;
    icon?: any;
    iconActive?: any;
    link: string;
    disabled?: boolean;
    className?: string;
    exact?: boolean;
    permission?: string | string[];
    target?: string;
}

export enum TransactionStatus {
    OK = 0,
    AUTH_DENIED = 1,
    COMMUNICATION_ERROR = 2,
    CRYPTOGRAPHY_ERROR = 3,
    PROC_CENTER_ERROR = 4,
    NOT_ENOUGH_MONEY = 5,
    PUBLISHER_UNAVAILABLE = 6,
}

/* export const arrayToObject = (array: any[], key?: string): any =>
    array.reduce((obj: any, item: any): any => {
        obj[item[key || 'id']] = item;
        return obj;
    }, {}); */

export const getAxiosData = (resp: Promise<any>) => resp.then((result) => result.data);
export const getRejectedRespData = (ev: any): any => (ev as any)?.response?.data && { ...ev.response.data };

export const getFullName = (item: any): string => {
    return ['lastName', 'firstName', 'middleName']
        .reduce((res: string[], key: string) => {
            item[key] && res.push(item[key]);
            return res;
        }, [])
        .join(' ');
};

export interface ISearchType {
    key: string;
    keysLocal?: string[];
    title: string;
    placeholder: string;
}

export interface IPaging {
    type?: string | null;
    first?: any;
    pageNumber?: any;
    pageSize?: any;
    pageCount?: any;
    rowsPerPage?: any[];
    totalPages?: any;
    totalRows?: any;
}

export const initPagingList: IPaging = {
    first: 0,
    pageNumber: 0,
    pageSize: ITEM_PER_PAGE,
    rowsPerPage: ROWS_PER_PAGE,
};

export const initPagingGrid: IPaging = {
    first: 0,
    pageNumber: 0,
    pageSize: ITEM_PER_PAGE_GRID,
    rowsPerPage: ROWS_PER_PAGE_GRID,
};

export interface IListResp {
    page: any[];
    totalPages?: any;
    totalRows?: any;
}

export const replaceSearchKey = (data: any = {}): any => {
    return Object.keys(data).reduce((res, key) => {
        res[key.replace('search.', '')] = data[key];
        return res;
    }, {});
};
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const parsePagingToParams = (data: any = {}): any => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { first, pageCount, rowsPerPage, totalPages, totalRows, pageNumber = 0, pageSize = 10, ...rest } = data;
    return replaceSearchKey({ pageNumber, pageSize, ...rest });
};
export const parseToPaging = (data: any = {}): any => {
    const { page, rows, first, pageNumber: pageN = 0, pageSize: pageS = 10 } = data;
    const pageNumber = page || pageN;
    const pageSize = rows || pageS;
    return { pageNumber, pageSize, first: first || pageNumber * pageSize || 0 };
};

export const VALID_MESSAGE = {
    required: "Це поле є обов'язковим для заповнення.",
    notUnique: 'Це поле повинно бути унікальним! Вже є сутність з такою назвою.',
    noValidPattern: 'Не валідний патерн',
    pattern: 'Це поле повинно слідувати моделі',
    patternNumber: 'Це поле має бути числом',
    patternEdrpou: 'Це поле повинно мати 8 знаків',
    patternEmail: 'Це поле має відповідати формату email',
    patternIP: 'Це поле має бути IP-адресою',
    patternAssetNumber: 'Це поле має бути коротшим за 33 символа',
    patternLength255: 'Це поле має бути коротшим за 256 символа',
    patternPercent: 'Це поле не повинно містити проценти та не перевищувати 100',
    positiveNum: 'Це поле повинне бути більше нуля',
    optSheetNumber: 'Це поле повинно мати 13 знаків',
    optAddress: 'Це поле повинно бути від 38 до 53',
    onlyNumber: 'Це поле повинно мати тількт цифри',
    numberFrom0To1: 'Це поле повинно бути від 0 до 1, та може мати 2 знаки після крапки',
    numberFrom1To10: 'Це поле повинно бути від 1 до 10',
    numberFrom1To100: 'Це поле повинно бути від 1 до 100',
    numberFrom1000To9500: 'Це поле повинно бути від 1000 до 9500',
    bankCard: 'Це поле повинно містити "*" або число від 1 до 16 знаків',
};

export const REG_EX = {
    EMAIL: /\S+@\S+\.\S+/,
    IP: /^(?!\.)((^|\.)([1-9]?\d|1\d\d|2(5[0-5]|[0-4]\d))){4}$/,
    PORT: /^\d{1,}$/,
    EDRPOU: /^\d{8}$/,
    ASSET_NUMBER: /^.{1,32}$/,
    LENGTH_255: /^.{1,255}$/,
    PERCENT: /^(100|\d{1,2}(\.\d{0,2})?)$/,
    POSITIVE_NUM: /^(?!-)\d+(\.\d+)?$/,
    ONLY_NUMBER: /^[\d]*$/,
    NUMBER_FROM_0_TO_1: /^(0(\.\d{1,2})?|0|1)$/,
    NUMBER_FROM_1_TO_100: /^(100|[1-9]\d?)$/,
};

export default config;
